import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
// import Home from '../views/coachAssessmentDetail.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue'),
    },
    {
        path: '/teams',
        name: 'teams',
        component: () => import(/* webpackChunkName: "about" */ '../views/teams.vue'),
    },
    {
        path: '/app_voice',
        name: 'app_voice',
        component: () => import(/* webpackChunkName: "about" */ '../views/app_voice.vue'),
    },
    {
        path: '/about',
        name: 'About',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
        children: [
            {
                path: '/about/main_btn',
                name: 'main_btn',
                meta: {
                    keepAlive: false, // 不需要被缓存,
                    promptMsg:' 报告的名称， 比如 紫禁勇士，球队总结，或者 紫禁勇士，运动表现',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/MainBtn.vue'),
            },
            {
                path: '/about/introduce',
                name: 'introduce',
                meta: {
                    keepAlive: false, // 需要被缓存
                    speakStr:'这是俱乐部介绍',
                    promptMsg:'精彩瞬间 或者 紫禁勇士，视频资料',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/introduce.vue'),
            },
            {
                path: '/about/smartPitch',
                name: 'smartPitch',
                meta: {
                    keepAlive: false, // 需要被缓存
                    speakStr:'这是智慧球场列表',
                    promptMsg:'1号场地，2号场地 或者 返回',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/smartPitch.vue'),
            },
            {
                path: '/about/smartPitch/camera',
                name: 'smartPitchCamera',
                meta: {
                    keepAlive: false, // 需要被缓存
                    promptMsg:'返回',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/smartPitchDetail.vue'),
            },
            {
                path: '/about/moment',
                name: 'moment',
                meta: {
                    keepAlive: false, // 需要被缓存
                    speakStr:'这是俱乐部精彩瞬间',
                    promptMsg:'返回 或者 紫禁勇士，回到首页',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/moment.vue'),
            },
            {
                path: '/about/assessmentReport',
                name: 'assessmentReport',
                meta: {
                    keepAlive: false, // 需要被缓存
                    speakStr:'的评估报告',
                    promptMsg:'1号球员，2号球员 或者 球员姓名',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/assessmentReport.vue'),
            },
            {
                path: '/about/assessmentReportDetail/:id/',
                name: 'assessmentReportDetail',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    promptMsg:' 返回，或者 回到开始',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/assessmentReportDetail.vue'),
            },


            {
                path: '/about/teamReport',
                name: 'teamReport',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    speakStr:'的概况',
                    promptMsg:'查看伤病报告，或者训练计划',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/teamReport.vue'),
            },
            {
                path: '/about/injuryReport',
                name: 'injuryReport',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    speakStr:'的伤病概况',
                    promptMsg:'1号球员，2号球员 或者 球员姓名',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/injuryReport.vue'),
            },
            {
                path: '/about/injuryDetail/:id/:injuryImg/:number',
                name: 'injuryDetail',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    promptMsg:' 返回，或者 回到开始',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/injuryDetail.vue'),
            },
            {
                path: '/about/trainingReport',
                name: 'trainingReport',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    speakStr:'的训练计划',
                    promptMsg:'查看运动表现',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/trainingReport.vue'),
            },
            {
                path: '/about/videoList',
                name: 'videoList',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    speakStr:'的视频列表',
                    promptMsg:'”1号视频“，”2号视频”，“6号视频“ 或者 紫禁勇士，回到首页',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/videoList.vue'),
            },
            {
                path: '/about/videoClipList',
                name: 'videoClipList',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    speakStr:'的精彩视频片段列表',
                    promptMsg:'”1号视频“，”2号视频”，“6号视频“ 或者 紫禁勇士，返回',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/videoClipList.vue'),
            },
            {
                path: '/about/lessonPlan',
                name: 'lessonPlan',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    speakStr:'这是俱乐部的训练教案',
                    promptMsg:'”1号教案“，”2号教案“。如果您想看下一页的教案，可以说：下一页',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/lessonPlan.vue'),
            },
            {
                path: '/about/lessonDetail',
                name: 'lessonDetail',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    promptMsg:'训练视频 或者 返回',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/lessonDetail.vue'),
            },

            {
                path: '/about/playersReport',
                name: 'playersReport',
                meta: {
                    keepAlive: false, // 需要被缓存
                    speakStr:'的球员列表',
                    promptMsg:'1号球员，2号球员 或者 球员姓名',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/playersReport.vue'),
            },
            {
                path: '/about/playersDetail/:id',
                name: 'playersDetail',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    promptMsg:' 返回，或者 回到开始',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/playersDetail.vue'),
            },
            {
                path: '/about/coachList',
                name: 'coachList',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    speakStr:'的教练员列表',
                    promptMsg:'1号教练员，2号教练员 或者 教练员的名字',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/coachList.vue'),
            },
            {
                path: '/about/coachDetail/:id',
                name: 'coachDetail',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    promptMsg:' 返回，或者 回到开始',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/coachDetail.vue'),
            },
            {
                path: '/about/coachAssessment',
                name: 'coachAssessment',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    speakStr:'的教练员评估列表',
                    promptMsg:'1号教练员，2号教练员 或者 教练员的名字 或者 训练计划',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/coachAssessment.vue'),
            },
            {
                path: '/about/coachAssessmentDetail/:id',
                name: 'coachAssessmentDetail',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    promptMsg:' 返回，或者 回到开始',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/coachAssessmentDetail.vue'),
            },



            {
                path: '/about/dataReport/athleticPerformance',
                name: 'dataReport/athleticPerformance',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    speakStr:'的梯队数据分析',
                    promptMsg:'训练视频 或者 勇士，回到首页',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/dataReport/athleticPerformance.vue'),
            },
            {
                path: '/about/dataReport/intensityReport',
                name: 'dataReport/intensityReport',
                meta: {
                    speakStr:'的强度报告',
                    keepAlive: false, // 不需要被缓存
                    promptMsg:'球员名字 或者 勇士，训练教案 ',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/dataReport/intensityReport.vue'),
            },
            {
                path: '/about/dataReport/intensityReportDetail/:id/:name',
                name: 'dataReport/intensityReportDetail',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    promptMsg:' 返回，或者 回到开始',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/dataReport/intensityReportDetail.vue'),
            },
            {
                path: '/about/dataReport/AC_report',
                name: 'dataReport/AC_report',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    speakStr:'的概况',
                    promptMsg:'球员的名字， 或者 勇士，返回',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/dataReport/AC_report.vue'),
            },
            {
                path: '/about/dataReport/AC_reportDetail/:id/:name',
                name: 'dataReport/AC_reportDetail',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    promptMsg:' 返回，或者 回到开始',//页脚提示信息
                },
                component: () => import(/* webpackChunkName: "about" */ '../views/dataReport/AC_reportDetail.vue'),
            },
            {
                path: '/about/dataReport/AC_AIM',
                name: 'dataReport/AC_AIM',
                meta: {
                    speakStr:'的AC目标报告',
                    keepAlive: false, // 不需要被缓存
                    promptMsg:'球员名字 或者 勇士，返回 ',//页脚提示信息
                },
                component: () => import( '../views/dataReport/AC_AIM.vue'),
            },
            {
                path: '/about/dataReport/AC_AIM_Detail/:id/:name',
                name: 'dataReport/AC_AIM_Detail',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    promptMsg:' 返回，或者 回到开始',//页脚提示信息
                },
                component: () => import( '../views/dataReport/AC_AIM_Detail.vue'),
            },
            {
                path: '/about/dataReport/match_day',
                name: 'dataReport/match_day',
                meta: {
                    speakStr:'的比赛日分析',
                    keepAlive: false, // 不需要被缓存
                    promptMsg:'球员名字 或者 勇士，返回 ',//页脚提示信息
                },
                component: () => import( '../views/dataReport/match_day.vue'),
            },
            {
                path: '/about/dataReport/match_day_detail/:id/:name',
                name: 'dataReport/match_day_detail',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    promptMsg:' 返回，或者 回到开始',//页脚提示信息
                },
                component: () => import( '../views/dataReport/match_day_detail.vue'),
            },
            {
                path: '/about/dataReport/player_data',
                name: 'dataReport/player_data',
                meta: {
                    speakStr:'的球员数据分析',
                    keepAlive: false, // 不需要被缓存
                    promptMsg:'球员名字 或者 勇士，返回 ',//页脚提示信息
                },
                component: () => import( '../views/dataReport/player_data.vue'),
            },
            {
                path: '/about/dataReport/player_data_detail/:id/:name',
                name: 'dataReport/player_data_detail',
                meta: {
                    keepAlive: false, // 不需要被缓存
                    promptMsg:' 返回，或者 回到开始',//页脚提示信息
                },
                component: () => import( '../views/dataReport/player_data_detail.vue'),
            },
        ]
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
